// src/components/MainLayout/MainLayout.js
import React, { useState } from "react";
import NavBar from "../Navbar/NavBar";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  const [menuToggle, setMenuToggle] = useState(false);
  return (
    <div className="app-layout">
      <NavBar setMenuToggle={setMenuToggle} />
      <div
        className="layout-body"
        style={{ display: "flex", minHeight: "calc(100vh - 80px)" }}
      >
        <Sidebar menuToggle={menuToggle} setMenuToggle={setMenuToggle} />
        {menuToggle && (
          <div className="overlay" onClick={() => setMenuToggle(false)}></div>
        )}
        <main className="content" style={{ flex: 1, background: "#f7f7f7 ", overflow: "auto" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
